// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TGetFederalSubjectsOfRussiaModel,
  IMappers,
  TGetFederalSubjectsOfRussiaResponse,
  IGetFederalSubjectsOfRussiaResponse,
  IGetFederalSubjectsOfRussiaResponseError,
} from './types';

export const defaultConfig: TGetFederalSubjectsOfRussiaModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'geo-temp-layer',
  pathApi: '/v1/get-federal-subjects-of-russia/',
} as TGetFederalSubjectsOfRussiaModel;

export function createGetFederalSubjectsOfRussiaModel(): TGetFederalSubjectsOfRussiaModel {
  return {
    ...defaultConfig,
  };
}

export interface IGetFederalSubjectsOfRussiaOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetFederalSubjectsOfRussia<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetFederalSubjectsOfRussiaOptions<TResponse200, TResponse400>): Promise<
  TGetFederalSubjectsOfRussiaResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetFederalSubjectsOfRussiaModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFederalSubjectsOfRussiaResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetFederalSubjectsOfRussiaResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetFederalSubjectsOfRussiaResponse;
}
